<template>
  <section class="section" id="courses">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <h1 class="title has-text-centered is-spaced">
        <span class="is-pulled-left">
          <router-link class="button" tag="button" to="/dashboard">
            <b-icon icon="arrow-alt-circle-left"></b-icon>
          </router-link>
        </span>
        {{ $t("courses.title") }}
      </h1>
      <hr />
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common.js";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false
    };
  }
};
</script>

<style scoped>
#courses {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
